import { render, staticRenderFns } from "./ks2-review-new.vue?vue&type=template&id=4f9922a2&lang=pug&"
import script from "./ks2-review-new.vue?vue&type=script&lang=ts&"
export * from "./ks2-review-new.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports